import { cn, Command, CommandItem, CommandList } from '@duck/ui'
import { TableCellsIcon } from '@heroicons/react/24/outline'
import { getTableDataFromQuery } from './utils'
import { KeyRound } from 'lucide-react'
import { useEventEmitter } from '@/modules/EventBusModule'

const InlineCode = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <code
      className={cn(
        'bg-muted/60 relative rounded px-[0.3rem] py-[2px] font-mono text-sm',
        className
      )}
    >
      {children}
    </code>
  )
}

interface DatabaseSchemaProps {
  tableQueries: string[];
}

type FieldWithIcon = {
  name: string;
  type: string;
  icon?: React.ReactNode;
};

export const DatabaseSchema = ({ tableQueries }: DatabaseSchemaProps) => {
  const emitInsert = useEventEmitter('codeInput:insert')

  const handleValueClick = (value: string) => {
    emitInsert({ value })
  }

  return (
    <>
      <div className="space-y-3">
        {tableQueries.map((query, index) => {
          const { name, fields } = getTableDataFromQuery(query)
          const fieldsWithIcon: FieldWithIcon[] = fields.map((field) => ({
            ...field,
          }))
          return (
            <div
              key={index}
              className="border border-border rounded overflow-hidden"
            >
              <div className="flex items-center justify-between bg-secondary/50 ">
                <div
                  className="px-4 py-2 flex items-center gap-2 cursor-pointer"
                  onClick={() => handleValueClick(name)}
                >
                  <TableCellsIcon className="w-4 h-4 text-primary" />
                  <span className="text-sm font-semibold text-foreground">
                    {name}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <div className="flex flex-wrap gap-2">
                  <Command>
                    <CommandList>
                      {fieldsWithIcon.map((field, index) => (
                        <CommandItem
                          key={field.name}
                          className="cursor-pointer"
                          onSelect={() => handleValueClick(field.name)}
                        >
                          <span className="min-w-4 me-2">
                            {field.type
                              ?.toUpperCase()
                              .includes('PRIMARY KEY') ? (
                              <KeyRound className="w-4 h-4 text-primary" />
                            ) : null}
                          </span>
                          <span className="me-2">
                            <InlineCode className="">{field.name}</InlineCode>
                          </span>
                          <span className="whitespace-nowrap text-muted-foreground text-[11px]">
                            {field.type}
                          </span>
                          {/* </Badge> */}
                        </CommandItem>
                      ))}
                    </CommandList>
                  </Command>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
